import "../css/style.scss"
// import "../script/JSCopyright.js"
import "../script/JSCourriel.js"
import "../script/JSFonctions.js"
